import { Link, SpaceBetween } from '@cloudscape-design/components';
import { Box } from '@cloudscape-design/components';
import { useMemo } from 'react';
import { ReportDownloadButton } from './ReportDownloadButton';
import type { PlaceReportSmall } from '../common/types';

type ReportSource = 'google' | 'yelp';

export type PlacePeriodListProps = {
  report: PlaceReportSmall;
  name: string;
  source?: string;
  hideDownload?: boolean;
  hideDetails?: boolean;
};

export function PlacePeriodList(props: PlacePeriodListProps) {
  const periods = useMemo(() => {
    return props.report.periods
      .filter((period) => (period.source ?? 'google') === (props.source ?? 'google'))
      .sort((a, b) => {
        return new Date(b.end_date).getTime() - new Date(a.end_date).getTime();
      })
      .slice(0, 4);
  }, [props.report.periods, props.source]);

  return (
    <SpaceBetween size="xxxs" direction="vertical">
      {periods.map((period) => (
        <div key={period.uuid}>
          {!props.hideDownload && (
            <ReportDownloadButton
              item={props.report}
              period={period.range}
              variant="inline-link"
              defaultSource={(props.source ?? 'google') as ReportSource}
              sources={props.source ? [(props.source ?? 'google') as ReportSource] : undefined}
            />
          )}
          <Link
            key={period.uuid}
            href={`/${props.report.slug ?? props.report.uuid}?range=${period.range}` + (props.source ? `&source=${props.source}` : '')}
            variant="secondary"
            target="_blank"
          >
            {period.range}: {period.place_letter_grade}
            {!props.hideDetails && (
              <> ({(100 * period.place_percentile).toFixed(1)}%){' '}
              {`${period.review_count}|${period.average_rating.toFixed(1)}|${(period.response_rate * 100).toFixed(0)}%|${period.avg_response_time}`}</>
            )}
          </Link>
        </div>
      ))}
      {periods.length === 0 && (
        <Box variant="span" color="text-body-secondary">
          No scores for {props.source ? props.source[0].toUpperCase() + props.source.slice(1) : 'Google'}
        </Box>
      )}
    </SpaceBetween>
  );
}
